const todoData = {
  todo: ["Change the UI of some popup menus"],
  workingOn: ["Build order page content", "Fix all mobile view issues"],
  achieved: [
    "Build order page",
    "Build working on menu",
    "Confirm receive order product button",
    "Add X mark for some menus",
  ],
};

export default todoData;
